// if (module.hot) {
//   module.hot.accept();
//   module.hot.decline('./routes.js');
// }

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import promise from 'redux-promise';

require('babel-polyfill');

import reducers from './reducers';
import App from './components/app';

const createStoreWithMiddleware = applyMiddleware(
  promise
)(createStore);

const store = createStoreWithMiddleware(reducers);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.querySelector('#app-entry-point')
);

// Post iframe Height to Parent
setInterval(() => {
  const documentHeight = Math.max(
    document.body.scrollHeight, document.documentElement.scrollHeight
  );
  window.parent.postMessage({ iFrameHeight: documentHeight }, '*');
}, 1000);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/